import * as React from "react";
const SvgWizardFieldStandard = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 4, y1: 42, x2: 60, y2: 42, stroke: "currentColor", strokeWidth: 2 }));
export default SvgWizardFieldStandard;
